export default ({
    namespaced: true,

    state: () => ({
        currentStep: 'Planos',
        steps: ['Planos', 'Dados', 'Confirmação']
    }),

    getters: {
        getStep(state){
            return state.currentStep
        },
        getSteps(state) {
            return state.steps
        }

    },

    mutations: {
        SET_STEP(state, step){
            state.currentStep = step
        }
    },

    actions: {
        setStep({commit}, step){
            commit('SET_STEP', step);
        }
    }

})